import addSimpleGeoJsonSource from '../layer-utils/add-simple-geojson-source';
import MapLayer from '../map-layer.enum';

function addIncidentDatumSource(layer: MapLayer | string) {
  addSimpleGeoJsonSource(layer);
}

export default addIncidentDatumSource;
